var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        [_c("v-tab", [_vm._v("Asignación de Vehículos a Endpoint")])],
        1
      ),
      _c("v-divider"),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs10: "", sm10: "", md10: "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs5: "", sm5: "", md5: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: _vm.formFields.clientes.label,
                          items: _vm.clientesAll,
                          "item-text": _vm.formFields.clientes.formatItem,
                          "item-value": "id",
                          "data-vv-name": "selectedValue",
                          color: "primary",
                          clearable: true,
                          "no-data-text": "Cargando...",
                          required: ""
                        },
                        model: {
                          value: _vm.formFields.clientes.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.clientes, "value", $$v)
                          },
                          expression: "formFields.clientes.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c("v-flex", { attrs: { xs1: "", sm1: "", md1: "" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "text-sm-center botones-filtros",
                        staticStyle: {
                          "padding-right": "20px",
                          "padding-left": "20px",
                          display: "block",
                          margin: "0 0 0 auto",
                          "margin-top": "15px"
                        }
                      },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c("v-icon", _vm._g({}, on), [
                                      _vm._v("report_problem")
                                    ])
                                  ]
                                }
                              }
                            ])
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "Si desea cambiar de cliente, selecciónelo de la lista y de\n                click a 'Filtrar'"
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _c("v-flex", { attrs: { xs2: "", sm2: "", md2: "" } }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center botones-filtros" },
                      [
                        _c(
                          "v-btn",
                          { on: { click: _vm.showTable } },
                          [
                            _c("v-icon", [_vm._v("search")]),
                            _vm._v("Filtrar ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c("v-flex", { attrs: { xs2: "", sm2: "", md: "" } }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center botones-filtros" },
                      [
                        _c(
                          "v-btn",
                          { on: { click: _vm.clearFilters } },
                          [
                            _c("v-icon", [_vm._v("clear")]),
                            _vm._v("Limpiar\n            ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      !_vm.showTables
        ? _c("div", { staticStyle: { "text-align": "center" } }, [
            _c("div", { attrs: { id: "textEmpty" } }, [
              _vm._v("No ha seleccionado ningún cliente")
            ]),
            _c("img", { attrs: { src: require("@/assets/emptyIcon.png") } })
          ])
        : _vm._e(),
      _c(
        "v-layout",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showTables,
              expression: "showTables"
            }
          ],
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs4: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Buscar", clearable: "", outlined: "" },
                on: {
                  keyup: function($event) {
                    return _vm.gridApi.setQuickFilter(_vm.filtro)
                  },
                  "click:clear": function($event) {
                    return _vm.gridApi.setQuickFilter("")
                  }
                },
                model: {
                  value: _vm.filtro,
                  callback: function($$v) {
                    _vm.filtro = $$v
                  },
                  expression: "filtro"
                }
              })
            ],
            1
          ),
          _c("v-flex", {
            attrs: { xs12: "", sm6: "", md6: _vm.accionCrear.visible }
          }),
          _c(
            "v-flex",
            {
              staticStyle: { "padding-right": "0px" },
              attrs: { xs12: "", sm6: "", md2: "" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "6px", "padding-right": "0px" },
                  attrs: { align: "right" }
                },
                [
                  _vm.accionCrear.visible
                    ? _c(
                        "v-btn",
                        {
                          staticStyle: { "padding-right": "20px" },
                          attrs: { color: "#ffe800" },
                          on: {
                            click: function($event) {
                              _vm.showModalNew = true
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticStyle: { color: "black" },
                              attrs: { dark: "", left: "" }
                            },
                            [_vm._v("add_circle_outline")]
                          ),
                          _c("span", { staticStyle: { color: "black" } }, [
                            _vm._v("Crear")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showTables,
              expression: "showTables"
            }
          ],
          staticClass: "gridcard rounded-card proveedores"
        },
        [
          _c("MantenedorGridSinCodigo", {
            staticClass: "ag-theme-material",
            staticStyle: {
              width: "100%",
              height: "400px",
              "font-family": "'Asap' sans-serif"
            },
            attrs: {
              gridOptions: _vm.gridOptions,
              funcionalidadId: _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _vm.showModalEdit
        ? _c("FormEditarAsignacionVehiculos", {
            attrs: {
              esEdicion: _vm.modalEsEdicion,
              edited: _vm.editedIndex,
              clienteId: _vm.formFields.clientes.value,
              endPoints: _vm.endPoints
            },
            on: {
              modalAsociacionEmit: function($event) {
                return _vm.moduloModalCallback($event)
              },
              datoEditado: function($event) {
                return _vm.datoEditado($event)
              }
            }
          })
        : _vm._e(),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.showModalNew,
          titulo: _vm.$t("mensajes.mensajesVehiculosWS.titulo"),
          mensaje: _vm.$t("mensajes.mensajesVehiculosWS.mensaje"),
          mostrarBoton: false,
          textoBtnSi: _vm.$t("mensajes.mensajesVehiculosWS.btnAceptar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }